import React, { Component } from 'react'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import ImgGallery from '@common/ImgGallery'
import { message } from 'hljd'
import { getImageAutoOrientLink } from '@util'

@observer
export default class extends Component {
  onChange = name => value => {
    const { onValueChange } = this.props.store
    onValueChange(name)(value)
  }

  validator = (file, link, info) => {
    const { width: limitWidth, height: limitHeight } = this.props
    getImageAutoOrientLink(link, { ...info }) // 修复下info中的图片宽高
    const { width, height } = info

    if (width < limitWidth || height < limitHeight) {
      message.error(`图片宽度需大于${limitWidth}，高度需大于${limitHeight}`)
      return false
    } else {
      return true
    }
  }

  onError = (up, err) => {
    if (err.code === plupload.FILE_SIZE_ERROR) {
      message.error('图片尺寸超过限制')
    }
  }

  render() {
    const { store, width, height } = this.props
    return (
      <ImgGallery
        itemStyle={{
          width: 194,
          height: (194 * height) / width,
          backgroundColor: '#ffffff'
        }}
        limitHeight={height}
        limitWidth={width}
        height={120}
        width={(120 * width) / height}
        max={5}
        onRemove={store.onRemoveHeadImg}
        multiple={true}
        onOk={store.onUploadHeadImgs}
        imgList={store.headImgList}
        onSort={store.onHeadImgSort}
        clipabled
        sortabled
        aspect={width / height}
        onCliped={store.onHeadImgCliped}
        keyField="clipUrl"
        autoCut
        filters={{
          mime_types: [
            { title: 'Image files', extensions: 'jpg,png,jpeg,bmp' }
          ],
          max_file_size: '10mb'
        }}
        description={
          <div className={styles['upload_des']}>
            <div className={styles['upload_add']}>+</div>
            {/* <p>头图</p> */}
            <p>{`${width}*${height}`}px</p>
          </div>
        }
        uploadConfig={{
          noUploadMark: true,
          descriptionStyle: {
            top: width > height ? 17 : 80
          }
        }}
        validator={this.validator}
        uploadedImgStyle={{
          border: '1px dashed #d9d9d9',
          borderRadius: '6px',
          marginRight: '8px'
        }}
        onError={this.onError}
      />
    )
  }
}
